module.exports = __webpack_public_path__ + "static/media/Taghash_Illustration_02.9172d655.png";